import {createSelector} from "reselect";
import {getSquads, isAllFilled} from "apps/DRAW_PREDICTOR/modules/selectors/squads";
import {getUser} from "modules/selectors";
import {find, get} from "lodash";
import {getFanSentiments} from "apps/DRAW_PREDICTOR/modules/selectors";
import {IDrawPredictorStore} from "apps/DRAW_PREDICTOR/modules/types/store";

export const getFanSentimentsQuestions = createSelector(
	getFanSentiments,
	isAllFilled,
	getSquads,
	getUser,
	(sentiments, isPost, squads, user) => {
		const squad = find(squads, (squad) => squad.shortName === user.supportedCountry);
		const groupKeyPart = isPost ? "post_draw" : "pre_draw";
		const qualKeyPart = squad ? "_qual_teams" : "";
		const sentiment = get(sentiments, `${groupKeyPart}${qualKeyPart}`, []);

		return sentiment.map((question) => {
			if (question.playerOptions && squad) {
				return {
					...question,
					playerOptionsArray: get(question.playerOptions, squad.name, []),
				};
			}

			return question;
		});
	}
);

export const getFanSentimentsQuestionsWithAnswer = (state: IDrawPredictorStore) =>
	state.fanSentiments.questions;
